import { Component, OnDestroy } from '@angular/core';
import { ToastController, LoadingController, ModalController } from '@ionic/angular';
import { BaseClass } from 'src/app/shared/classes/base';
import { TranslationService } from 'src/app/shared/services/translation.service';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import {debounceTime, distinctUntilChanged} from 'rxjs/operators';
import { UsersService } from '../users.service';
import { UserVisibility } from '../_interfaces/user-visibility';
import { AddUserVisibilityRulesComponent } from './add-user-visibility-rules/add-user-visibility-rules.component';

@Component({
  selector: 'app-users-visibility',
  templateUrl: './users-visibility.page.html',
  styleUrls: [ './users-visibility.page.scss' ]
})
export class UsersVisiblityPage extends BaseClass implements OnDestroy {

  public users: Array<UserVisibility> = [];
  public usersCount: number = 0;

  private _searchSubject: Subject<string> = new Subject();
  private _currentPage: number = 1;
  private _searchValue: string = '';

  constructor(
    protected _toastController: ToastController,
    private _modalController: ModalController,
    protected _translationService: TranslationService,
    private _loadingController: LoadingController,
    private _router: Router,
    private _usersService: UsersService
  ) {
    super(_toastController, _translationService);
    this._setSearchSubscriptions();
  }

  ionViewWillEnter() {
    this._loadUsers();
  }

  public goBack(): void {
    this._router.navigate([ 'dashboard' ]);
  }

  public updateSearch(searchTextValue: string): void {
    this._searchSubject.next( searchTextValue );
  }

  public async goToAddUser() {
    const modal = await this._modalController.create({
      component: AddUserVisibilityRulesComponent
    });
    return await modal.present();
  }

  public manageUserVisibility(user: UserVisibility): void {
    this._router.navigate(['users/visibility/' + user.userId ]);
  }

  public goToPage(page: number): void {
    this._currentPage = page;
    this._loadUsers();
  }

  private async _loadUsers(): Promise<void> {
    const loading = await this._loadingController.create();
    await loading.present();

    this._usersService.getUsersVisibility(
      this._currentPage, 10, this._searchValue
    ).subscribe((response) => {
      this.users = response.data.users;
      this.usersCount = response.data.total;
      loading.dismiss();
    }, (error) => {
      loading.dismiss();
      this.notifyError( error );
    });
  }

  private _setSearchSubscriptions() {
    this._searchSubject.pipe(
        distinctUntilChanged(),
        debounceTime(1000)
    ).subscribe((searchValue: string) => {
      this._searchValue = searchValue;
      this._loadUsers();
    });
  }

  ngOnDestroy() {
    this._searchSubject.unsubscribe();
  }
}
